import React from 'react';

interface DeleteAccountConfirmModalProps {
    show: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    loading: boolean;
}

const DeleteAccountConfirmModal: React.FC<DeleteAccountConfirmModalProps> = ({ show, onCancel, onConfirm, loading }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/50 z-[250] backdrop-blur-xs flex items-center justify-center p-4 text-left">
            <div className="bg-[#2d312e] text-white rounded-2xl p-6 max-w-sm w-full shadow-2xl border border-neutral-700 animate-in zoom-in-95 duration-150">
                <h3 className="text-xl font-bold tracking-tight text-white mb-3" style={{ fontFamily: 'Comic Sans MS, Comic Sans, cursive' }}>Delete Account</h3>
                <p className="text-gray-300 text-sm leading-normal mb-6 font-medium">Are you sure you want to delete your account? This action cannot be undone and will cancel any active subscriptions.</p>
                <div className="flex justify-end gap-4">
                    <button type="button" onClick={onCancel} className="text-gray-400 font-extrabold hover:text-white transition-colors text-xs tracking-wider uppercase px-2 py-1">Cancel</button>
                    <button type="button" onClick={onConfirm} disabled={loading} className="text-emerald-400 font-extrabold hover:text-emerald-300 transition-colors text-xs tracking-wider uppercase px-2 py-1 disabled:opacity-40">
                        {loading ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteAccountConfirmModal;
